/* eslint-disable max-lines-per-function */
import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import {
  SelectOptionStyled,
  SelectOptionsListCheckboxContainerStyled,
  SelectOptionsListCheckboxStyled,
  SelectOptionsListContentWrapperStyled,
} from './Select.styled';

export const SelectOptionView = ({
  children,
  name,
  value,
  defaultChecked,
  onChange,
}: any) => {
  return (
    <SelectOptionStyled>
      <SelectOptionsListCheckboxStyled>
        <SelectOptionsListCheckboxContainerStyled>
          <Checkbox
            {...(defaultChecked ? { defaultChecked } : null)}
            onChange={onChange}
            value={value}
            label=''
            name={name}
          />
        </SelectOptionsListCheckboxContainerStyled>
      </SelectOptionsListCheckboxStyled>
      <SelectOptionsListContentWrapperStyled>
        {children}
      </SelectOptionsListContentWrapperStyled>
    </SelectOptionStyled>
  );
};
